import React from 'react'
import styles from './styles.module.scss'
import { HearkenStatus } from 'types/hearkenStatus'
import { Step } from './step'
import { StepState } from './StepState'
import IntlMessageFormat from 'intl-messageformat'

interface Props {
  hearkenStatus: HearkenStatus
  startCollecting?: string
  deadlineCollecting?: string
  deadlineVoting?: string
  startPublishing?: string
  startVoting?: string
}

// Okay, this is getting fun … since we want to show various times at various
// points in the lifecycle of this app, let's create a huge object that covers
// all possible combinations …
const dateAndLabelSettingsByActiveStep: {
  /** The active status */
  [K in HearkenStatus]: {
    /** The configuration for each step in the current active status */
    [K in HearkenStatus]: [
      /** State to display */
      StepState,

      /** Deadline date property to use */
      string?,

      /** Anchor for the description */
      string?
    ]
  }
} = {
  [HearkenStatus.COLLECTING]: {
    [HearkenStatus.COLLECTING]: ['active', 'deadlineCollecting', '#embed'],
    [HearkenStatus.VOTING]: ['upcoming', 'startVoting', undefined],
    [HearkenStatus.INVESTIGATING]: ['upcoming', undefined, undefined],
    [HearkenStatus.PUBLISHING]: ['upcoming', 'startPublishing', undefined]
  },
  [HearkenStatus.VOTING]: {
    [HearkenStatus.COLLECTING]: ['past', undefined, undefined],
    [HearkenStatus.VOTING]: ['active', 'deadlineVoting', '#embed'],
    [HearkenStatus.INVESTIGATING]: ['upcoming', undefined, undefined],
    [HearkenStatus.PUBLISHING]: ['upcoming', 'startPublishing', undefined]
  },
  [HearkenStatus.INVESTIGATING]: {
    [HearkenStatus.COLLECTING]: ['past', undefined, undefined],
    [HearkenStatus.VOTING]: ['past', undefined, undefined],
    [HearkenStatus.INVESTIGATING]: ['active', 'investigating', undefined],
    [HearkenStatus.PUBLISHING]: ['upcoming', 'startPublishing', undefined]
  },
  [HearkenStatus.PUBLISHING]: {
    [HearkenStatus.COLLECTING]: ['past', undefined, undefined],
    [HearkenStatus.VOTING]: ['past', undefined, undefined],
    [HearkenStatus.INVESTIGATING]: ['past', undefined, undefined],
    [HearkenStatus.PUBLISHING]: ['active', undefined, '#articles']
  }
}

export function Steps(props: Props) {
  const messages = require('./locale/de.yml')
  const { hearkenStatus } = props

  return (
    <>
      <h2 className='ui centered infographic small header'>
        So funktioniert es
      </h2>
      <div className={`${styles.stepsContainer}`}>
        {Object.entries(dateAndLabelSettingsByActiveStep[hearkenStatus]).map(
          ([key, [stepState, dateField, link]], index) => {
            const description = new IntlMessageFormat(
              messages['description'][hearkenStatus][key],
              'de-CH'
            ).format({ date: dateField ? props[dateField] : undefined })

            return (
              <Step
                key={key}
                stepType={key as HearkenStatus}
                stepState={stepState}
                number={index + 1}
                description={description}
                link={link}
              >
                {messages['stepDescription'][key]}
              </Step>
            )
          }
        )}
      </div>
    </>
  )
}
